"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsTab = void 0;
const router_1 = require("client/components/router");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const edit_settings_1 = require("../../components/edit-settings");
const store_1 = require("../../store");
let SettingsTab = class SettingsTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.onCancelEditSettings = () => {
            router_1.RouteManager.transitionTo("/pharmacies");
        };
        this.onSaveSettingsSite = async (site) => {
            if (site.id) {
                store_1.sitesDetailStore.saveSite(site);
            }
        };
    }
    render() {
        const siteId = Number(this.props.params[0]);
        return (React.createElement("div", { className: "sites__form" },
            React.createElement(edit_settings_1.EditSettings, { error: store_1.sitesDetailStore.site.error, loading: store_1.sitesDetailStore.site.loading, onCancel: this.onCancelEditSettings, onSave: this.onSaveSettingsSite, site: siteId ? store_1.sitesDetailStore.site.value : null })));
    }
};
SettingsTab = __decorate([
    mobx_react_1.observer
], SettingsTab);
exports.SettingsTab = SettingsTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/tabs/settings/settings.tsx
// module id = 4058
// module chunks = 0